import pulse from '@finn-no/pulse-sdk';
import { safeParseClientDate } from '../util/datetime-fns';

let widgetCount = 0;

const makeWidgetTracker =
    (type: 'hotel' | 'holiday_rental', intent: 'Show' | 'Click') => (checkInDate?: string, checkOutDate?: string, destination?: string) =>
        pulse.trackEvent({
            name: type === 'hotel' ? 'Hotel widget' : 'FHH widget',
            intent,
            type: 'View',
            object: {
                type: 'UIElement',
                elementType: 'Widget',
                id: `widget:${widgetCount++}`,
                items: [
                    {
                        type: 'Travel',
                        id: 'finntravel',
                        destination,
                        travelType: type,
                        departureDate: safeParseClientDate(checkInDate)?.toISOString(),
                        returnDate: safeParseClientDate(checkOutDate)?.toISOString(),
                    },
                ],
            },
        });

export const trackHotelWidgetImpression = makeWidgetTracker('hotel', 'Show');
export const trackHotelWidgetClick = makeWidgetTracker('hotel', 'Click');
export const trackFHHWidgetImpression = makeWidgetTracker('holiday_rental', 'Show');
export const trackFHHWidgetClick = makeWidgetTracker('holiday_rental', 'Click');
